module.exports = __webpack_public_path__ + "assets/img/998f61c5094f0abc7b3c0bb8a8ce638b.svg";